import Vue from 'vue'
import VueFormWizard from 'vue-form-wizard'
import 'vue-form-wizard/dist/vue-form-wizard.min.css'
import ElementUI from 'element-ui';
import money from 'v-money';
import VueNumeric from 'vue-numeric'
import VueTabs from 'vue-nav-tabs'
import PSwitch from 'src/components/UIComponents/Switch.vue';
import API from '@/services/API';
import Armazenamento from '@/services/Armazenamento';
import ExportarArquivos from './Exports/ExportarPDFeXLS'
import modoRelatorio from   'src/components/Dashboard/Views/Simulacoes/Relatorios/modoRelatorio/modoRelatorio'
import relatorio from '@/services/relatorio'

Vue.use(ElementUI);
Vue.use(money);
Vue.use(VueNumeric);
Vue.use(VueFormWizard);
Vue.use(VueTabs)

export default {
  name: 'ConfinamentoSimplesCtrl',
  components: {
    PSwitch,
    money,
    'exportar-pdf-xls': ExportarArquivos,
    'modo-relatorio':  modoRelatorio

  },
  created () {
    this.loading = true
    this.getInitialValues().then(([animais, descricoes, estados]) => {
      const assinatura = Armazenamento.assinatura.pegar()
      const valor = assinatura && assinatura.valor
      this.nomeImagemParceiro = valor && valor.cupom && valor.cupom.nomeImagemParceiro
      this.loading = false
      this.descricoes = descricoes;
      this.animais = animais;
      return this.getSimulation();
    })
  },
  data () {
    return {
      loader: false,
      loading: false,
      descricoes: null,
      resultados: {},
      entrada: {},
      retorno: {},
      animais: [],
      nomeImagemParceiro: null,
      urlPdf: null
    }
  },
  methods: {
    reload () {
      location.reload();
    },
    shouldShowPrefixAndSufix (val) {
      if (isNaN(Number(val))) {
        return false;
      }
      return false;
    },
    shouldShow (value) {
      for (let i = 0; i < value.length; i++) {
        if (this.entrada.modalidadeDeSistemaDeProducaoEscolhida === value[i]) {
          return true
        }
      }
      return false
    },
    shouldShowPrefixAndSufix (val) {
      if (isNaN(Number(val))) {
        return false;
      }
      return false;
    },
    getInitialValues () {
      const animais = API.listar.animais()
      const descricoes = API.listar.descricoes()
      const estados = API.listar.estados()
      return Promise.all([animais, descricoes, estados])
    },
    getSimulation () {
      let id = this.$router.history.current.params.id
      let that = this;
      if (id) {
        API.simulacao.buscar(id)
          .then(response => {
            if (response.status === 200) {
              this.retorno = response.data.simulacao;
              this.resultados = response.data.simulacao.simulacao_saida.dados.resultados;
              response.data.simulacao.simulacao_entrada.dados.racaDosAnimais = that.getRaca(response.data.simulacao.simulacao_entrada.dados.racaDosAnimais)[0].label;
              response.data.simulacao.simulacao_entrada.dados.padraoRacialPredominante = that.getPadraoRacial(response.data.simulacao.simulacao_entrada.dados.padraoRacialPredominante)[0].label;
              this.entrada = response.data.simulacao.simulacao_entrada.dados;
              console.log(response.data);
              this.exportReport()
            } else {
              console.log(' #getSimulation (then -> else) Algo deu errado, recarregue a página');
            }
          })
          .catch(e => {
            console.error(' #getSimulation (catch) Algo deu errado, recarregue a página');
            console.error(e);
          })
      }
    },
    getRaca (index) {
      let racas = [];
      for (let item = 0; item < this.animais.tipos[0].options.length; item++) {
        racas.push(this.animais.tipos[0].options[item])
      }
      for (let item = 0; item < this.animais.tipos[1].options.length; item++) {
        racas.push(this.animais.tipos[1].options[item])
      }
      racas = racas.filter(function (element) {
        return element.value === index
      })
      if (racas.length === 0) {
        return [{label: '-'}]
      }
      return racas
    },
    getPadraoRacial (index) {
      let padrao = [];
      for (let item = 0; item < this.animais.padrao.length; item++) {
        padrao.push(this.animais.padrao[item])
      }
      padrao = padrao.filter(function (element) {
        return element.value === index
      })
      return padrao
    },
    exportReport () {
      let doc = relatorio.consolidado.confinamento.avancado.criar(this)
      let pdfBlob = doc.output('blob')
      this.urlPdf = URL.createObjectURL(pdfBlob);
    },
    downloadReport () {
      let doc = relatorio.consolidado.confinamento.avancado.criar(this)
      doc.save('consolidado_confinamento_avancado.pdf')
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/Dashboard/Views/Simulacoes/Relatorios/Consolidado/Completo/Confinamento/CompletoCtrl.js